<!-- Header -->
<div class="cre-fleet-scoreboard-header">
  <span class="cre-fleet-scoreboard-competition">
    {{ competitionHeader }}
  </span>
  <span class="cre-fleet-scoreboard-tie-breaker" *ngIf="showTieBreaker">
    Tie Breaker
  </span>
</div>
<!-- Home Team -->
<div class="cre-fleet-scoreboard-row">
  <app-sport-team-logo [fleet]="homeFleet"></app-sport-team-logo>
  <div class="cre-fleet-scoreboard-team-container">
    <span>Fleet {{ homeFleet }}</span>
    <ng-content select="[home-information]"></ng-content>
  </div>
  <div
    class="cre-fleet-scoreboard-tag"
    [ngClass]="{
      'cre-fleet-scoreboard-tag-tie': isTie,
      'cre-fleet-scoreboard-tag-win': isHomeFleetWinner && !isTie,
      'cre-fleet-scoreboard-tag-loss': isAwayFleetWinner && hasCompetition && !isTie
    }"
  ></div>
  <span class="cre-fleet-scoreboard-competition" *ngIf="currentProgress !== 0; else completed">
    <div
      class="cre-fleet-state-tag"
      [ngClass]="{
        'cre-fleet-state-tag-in-progress': currentProgress === 1,
        'cre-fleet-state-tag-calculating': currentProgress === 2,
        'cre-fleet-state-tag-single': !hasCompetition
      }"
    ></div>
  </span>
  <ng-template #completed>
    <span class="cre-fleet-scoreboard-competition">
      {{ homeCompetition | number: '1.2-2' }}
    </span></ng-template
  >
  <span class="cre-fleet-scoreboard-tie-breaker" *ngIf="showTieBreaker">
    {{ homeTieBreaker | number: '1.2-2' }}
  </span>
</div>
<!-- Away Team -->
<div class="cre-fleet-scoreboard-row" *ngIf="awayFleet">
  <app-sport-team-logo [fleet]="awayFleet"></app-sport-team-logo>
  <div class="cre-fleet-scoreboard-team-container">
    <span>Fleet {{ awayFleet }}</span>
    <ng-content select="[away-information]"></ng-content>
  </div>
  <div
    class="cre-fleet-scoreboard-tag"
    [ngClass]="{
      'cre-fleet-scoreboard-tag-tie': isTie,
      'cre-fleet-scoreboard-tag-win': isAwayFleetWinner && !isTie,
      'cre-fleet-scoreboard-tag-loss': isHomeFleetWinner && !isTie
    }"
  ></div>
  <span class="cre-fleet-scoreboard-competition">
    {{ awayCompetition | number: '1.2-2' }}
  </span>
  <span class="cre-fleet-scoreboard-tie-breaker" *ngIf="showTieBreaker">
    {{ awayTieBreaker | number: '1.2-2' }}
  </span>
</div>
